import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/farmtradedirect/src/app/user-profile/components/UserProfileScreen.tsx");
